
    export var PACKAGE_VERSION = '3.0.0 (d60cf6e)';
    export var THEME = 'open-source-visual-refresh';
    export var ALWAYS_VISUAL_REFRESH = true;
    